import {
  Icon,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
} from "@chakra-ui/react";
import { BsClock } from "react-icons/bs";

export function PopoverHorario({
  popoverOpen,
  setPopoverOpen,
  isVisualizacao,
  children,
}) {
  return (
    <Popover isOpen={popoverOpen} onClose={() => setPopoverOpen(false)}>
      <PopoverTrigger>
        <Icon
          aria-label="Abrir seletor de horário"
          color="#9EA1AE"
          as={BsClock}
          boxSize="20px"
          _hover={{ cursor: isVisualizacao ? "" : "pointer" }}
          onClick={() => {
            isVisualizacao ? setPopoverOpen(false) : setPopoverOpen(true);
          }}
        />
      </PopoverTrigger>
      <PopoverContent w={"100%"}>
        <PopoverBody p={4}>{children}</PopoverBody>
      </PopoverContent>
    </Popover>
  );
}
